import { svg } from 'lit';

export const emailUnreadIcon = svg`
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2 5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5V19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19V5ZM4 7.04464V18H20V7.04464L12.6139 12.7894C12.2528 13.0702 11.7472 13.0702 11.3861 12.7894L4 7.04464ZM18.0855 6H5.91454L12 10.7331L18.0855 6Z" fill="currentColor"/>
  `;
